export default __webpack_public_path__ + "static/image13-6132941406bf4de3459762223e5f36f0.gif";